var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_56551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5Z",
    fill: "url(#paint0_linear_1543_56551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78236 12.1011L9.70168 10.7557C10.6312 9.39205 11.5611 8.03182 12.4914 6.675C12.7676 6.27387 13.1358 6.22046 13.5346 6.48864C13.6835 6.58977 13.8346 6.68523 13.9812 6.78864C14.3471 7.04773 14.4221 7.42727 14.1687 7.79887C13.1755 9.25796 12.1801 10.7159 11.1824 12.1727C10.6968 12.8811 10.2142 13.5898 9.73463 14.2989C9.45281 14.717 9.08804 14.7977 8.67327 14.5057C7.78463 13.8807 6.90092 13.2485 6.02213 12.6091C5.62781 12.3239 5.58122 11.9557 5.86531 11.5602C5.97895 11.4057 6.08463 11.2489 6.1994 11.0966C6.43577 10.7852 6.79145 10.7068 7.11986 10.9227C7.50281 11.175 7.87099 11.4511 8.24599 11.7182L8.78236 12.1011Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_56551",
    x1: 2.92841,
    y1: 3.42841,
    x2: 17.0716,
    y2: 17.5716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76EE1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BC21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_56551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.84ea2605fd1c6a07db04bd891dc16efe.svg";
export { ForwardRef as ReactComponent };